import { displayPercent } from "app/shared/util/percent";

export const columns: any = [
    {
        title: 'Tên đơn vị',
        key: 'ownerName',
        dataIndex: 'ownerName',
    },
    {
        title: 'Lần trình phê duyệt',
        key: 'submittedCount',
        dataIndex: 'submittedCount',
    },
    {
        title: 'Lập mục tiêu',
        key: 'submittedStatus',
        dataIndex: 'submittedStatus',
    },
];

export const columnsPreApproval: any = [
    {
        title: 'Lần trình phê duyệt',
        key: 'version',
        dataIndex: 'version',
    },
    {
        title: 'Lập mục tiêu',
        key: 'selfEvaluate',
        dataIndex: 'selfEvaluate',
    },
];

export const columnsApprove: any = [
    {
        title: '',
        key: 'itemCode',
        fixed: 'left',
        width: 120,
        dataIndex: 'itemCode',
    },
    {
        title: 'Mục tiêu & KR cả năm',
        fixed: 'left',
        key: 'purposeYear',
        width: 200,
        dataIndex: 'purposeYear',
    },
    {
        title: 'Tỷ trọng',
        fixed: 'left',
        key: 'contribution',
        width: 100,
        dataIndex: 'contribution',
        render: item => item && `${displayPercent(item)}%`
    },
    {
        title: 'KR quý 1',
        key: 'purposeQuarterOne',
        width: 200,
        dataIndex: 'purposeQuarterOne',
    },
    {
        title: 'KR quý 2',
        key: 'purposeQuarterTwo',
        width: 200,
        dataIndex: 'purposeQuarterTwo',
    },
    {
        title: 'KR quý 3',
        key: 'purposeQuarterThree',
        width: 200,
        dataIndex: 'purposeQuarterThree',
    },
    {
        title: 'KR quý 4',
        key: 'purposeQuarterFour',
        width: 200,
        dataIndex: 'purposeQuarterFour',
    },



];

